export default __webpack_public_path__ + "static/media/paymentSuccess.749e45c6.gif";